<template>
	<el-dialog title="商品" :visible.sync="visible" :before-close='onlineClose' width="1200px"
		:close-on-click-modal="false">
		<div class="page">
			<el-row class="titleView">
				<el-col :span="6" style="display: flex;align-items: center;margin-right: 20px;">
					<el-input v-model="keyword" prefix-icon="el-icon-search" placeholder="请输入内容" class="titleInput"
						clearable size="small"/>
					<el-button type="warning" style="margin-left: 10px;" @click="getTableData" size="small">搜索</el-button>
				</el-col>
				<el-col :span="5" class="flex">
					<div class="m-r-10">线上分类</div>
					<el-select v-model="categoryId" placeholder="请选择" class="titleSelect" @change="getTableData" size="small">
						<el-option v-for="item in classOptions" :key="item._id" :label="item.name" :value="item._id" />
					</el-select>
				</el-col>
				<el-col :span="13"></el-col>
			</el-row>
			<!-- 表格 -->
			<el-table :data="tableData" border>
				<el-table-column prop="title" label="商品名称" :key="1" align="center">
				</el-table-column>
				<el-table-column prop="online_name" label="线上名称" :key="2" align="center">
				</el-table-column>
				<el-table-column prop="online_category_info.name" label="线上分类" :key="3" align="center">
				</el-table-column>
				<el-table-column prop="brand_name" label="品牌" :key="4" align="center">
				</el-table-column>
				<el-table-column label="操作" :key="5" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="small" @click='select(scope.row)'>选择</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<page :page="page.page" :total="page.total" @change="changePage"></page>
		</div>
	</el-dialog>
</template>
<script>
	import page from "../components/page.vue"
	import {
		getClass,
		onlineGoods
	} from '../api/program.js'
	export default {
		components: {
			page
		},
		props: {
			onlineState: { //显示状态
				default: false
			}
		},
		data() {
			return {
				visible: true,
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				keyword:'', //关键字
				categoryId:'',  //线上分类
				classOptions:[], //分类
				tableData: [], //表格数据
			};
		},
		mounted() {
			this.getClassData()
			this.getTableData()
		},
		methods: {
			select(row){
				this.$emit("submit",row)
			},
			//获取表格
			getTableData(){
				let params = {
					pageIndex:this.page.page,
					pageSize:this.page.pageSize,
					keyword:this.keyword,
					categoryId:this.categoryId,
					status:1,
				}
				onlineGoods(params).then((res)=>{
					if(res.code == 0){
						console.log(res.data)
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
			//向父组件发射关闭弹框
			onlineClose(done) {
				done()
				this.$emit("closeOn", false);
			},
			//获取类别
			getClassData() {
				let params = {
					'pageIndex': 0,
					'pageSize': 0,
					'type': '商城分类',
					'class': '线上'
				}
				getClass(params).then((res) => {
					if (res.code == 0) {
						console.log('获取类别', res.data)
						this.classOptions = res.data.data
					}
				})
			},
		},
		watch: {
			// 监视状态发生改变
			onlineState() {
				this.visible = this.onlineState;
			},
		}
	};
</script>

<style lang="scss" scoped="scoped">
	.titleView {
		height: 72px;
		line-height: 72px;
		display: flex;
		background: #fff;
		justify-content: space-around;
		align-items: center;
		border-radius: 6px;
		margin-bottom: 10px;

		.titleInput {
			width: 192px;
		}

		.titleDate {
			width: 224px;
		}

		.titleSelect {
			width: 126px;
		}
	}

	.flex {
		display: flex;
		align-items: center;
	}

	.m-r-10 {
		margin-right: 10px;
	}
</style>
